<script setup lang="ts"></script>

<template>
  <div
    :class="$style.tablePageShadowWrapper"
    data-testid="tablePageShadowWrapper"
  >
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tablePageShadowWrapper {
  box-shadow: variables.$tableShadow;
  // border-radius: 8px;
  // overflow: hidden; // TODO sticky table header
  padding-bottom: 1px;
  background-color: colors.$color-white;
}
</style>
